export function calculateBaseScores(quiz, answers) {
    const scores = Object.fromEntries(quiz.scoring.categories.map((category) => [category, 0]));
    for (const question of quiz.questions) {
        const answerId = answers[question.id];
        if (!answerId)
            continue;
        const answer = question.answers.find((candidate) => candidate.id === answerId);
        for (const [category, value] of Object.entries(answer?.scores ?? {})) {
            scores[category] = (scores[category] ?? 0) + value;
        }
    }
    return scores;
}
export function normalizeScores(scores, normalizeTo = 100) {
    const maxScore = Math.max(1, ...Object.values(scores));
    return Object.fromEntries(Object.entries(scores).map(([category, value]) => [category, Math.round((value / maxScore) * normalizeTo)]));
}
